import { api, authHeader } from "../configs/axiosConfigs";

const getRoleInfoListApi = async () => {
  const response = await api.request({
    url: `UM/RoleInfo/GetList`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const getCreateRoleInfoApi = async () => {
  const response = await api.request({
    url: `UM/RoleInfo/Create`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const getRoleInfoByIdApi = async (id) => {
  const response = await api.request({
    url: `UM/RoleInfo/GetRoleInfoById${id ? "?Id=" + id : ""}`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const modifyRoleInfoApi = async (data, roleId) => {
  const queryId =
    roleId != null && Number(roleId) > 0
      ? Number(roleId)
      : data?.role?.roleId != null && Number(data.role.roleId) > 0
      ? Number(data.role.roleId)
      : 0;

  const response = await api.request({
    url: `UM/RoleInfo/Modify?id=${queryId}`,
    method: "Post",
    data: data,
    headers: authHeader(),
  });

  return response.data;
};

const deleteRoleInfoApi = async (data) => {
  const response = await api.request({
    url: `UM/RoleInfo/Delete`,
    method: "Delete",
    data,
    headers: authHeader(),
  });

  return response.data;
};

// user info
const getUserInfoListApi = async () => {
  const response = await api.request({
    url: `UM/UserInfo/GetList`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const getUserInfoByIdApi = async (id) => {
  const response = await api.request({
    url: `UM/UserInfo/GetById?Id=${id}`,
    method: "GET",
    headers: authHeader(),
  });

  return response.data;
};

const modifyUserInfoApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/Modify`,
    method: "Post",
    data: data,
    headers: authHeader(),
  });

  return response.data;
};

const deleteUserInfoApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/Delete`,
    method: "Delete",
    data,
    headers: authHeader(),
  });

  return response.data;
};

const changeUserPasswordApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/ChangePassword`,
    method: "Post",
    data,
    headers: authHeader(),
  });

  return response.data;
};

const deleteAllUserDataApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/DeleteAllUserData`,
    method: "POST",
    data: data || {},
    headers: authHeader(),
  });

  return response.data;
};

const previewDeleteAllUserDataApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/PreviewDeleteAllUserData`,
    method: "POST",
    data: data || {},
    headers: authHeader(),
  });

  return response.data;
};

const changeUserMobileApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/ChangeMobile`,
    method: "POST",
    data: data || {},
    headers: authHeader(),
  });

  return response.data;
};

const deleteRequestDataApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/DeleteRequestData`,
    method: "POST",
    data: data || {},
    headers: authHeader(),
  });

  return response.data;
};

const previewDeleteRequestDataApi = async (data) => {
  const response = await api.request({
    url: `UM/UserInfo/PreviewDeleteRequestData`,
    method: "POST",
    data: data || {},
    headers: authHeader(),
  });

  return response.data;
};

const impersonateUserApi = async (userInfoId) => {
  const response = await api.request({
    url: `UM/UserInfo/Impersonate`,
    method: "POST",
    data: { id: userInfoId },
    headers: authHeader(),
  });

  return response.data;
};

const syncMissingUserInfoApi = async () => {
  const response = await api.request({
    url: `UM/UserInfo/SyncMissingUserInfo`,
    method: "POST",
    headers: authHeader(),
  });

  return response.data;
};

const UserManagementService = {
  getRoleInfoListApi,
  getCreateRoleInfoApi,
  getRoleInfoByIdApi,
  modifyRoleInfoApi,
  deleteRoleInfoApi,
  getUserInfoListApi,
  getUserInfoByIdApi,
  modifyUserInfoApi,
  deleteUserInfoApi,
  changeUserPasswordApi,
  deleteAllUserDataApi,
  previewDeleteAllUserDataApi,
  changeUserMobileApi,
  deleteRequestDataApi,
  previewDeleteRequestDataApi,
  syncMissingUserInfoApi,
  impersonateUserApi,
};

export default UserManagementService;
